import {useCallback, useEffect, useRef, useState} from 'react';

// Hledání v popupu se sekcí otevřenou z monitoringu. Při otevření se pole
// předvyplní (typicky jménem uživatele), psaní se debouncuje a programová změna
// (klik na sloupec grafu, na jméno v kartě) se propíše hned.
// Při zavírání hodnotu necháváme, ať obsah během animace nezmizí.
export default function usePopupSearch(isOpen, initialValue = '', debounceMs = 500) {
	const [searchInput, setSearchInput] = useState(initialValue);
	const [search, setSearch] = useState(initialValue);
	const debounceRef = useRef(null);

	const clearDebounce = useCallback(() => {
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
			debounceRef.current = null;
		}
	}, []);

	useEffect(() => clearDebounce, [clearDebounce]);

	useEffect(() => {
		if (isOpen) {
			clearDebounce();
			setSearchInput(initialValue);
			setSearch(initialValue);
		}
	}, [isOpen, initialValue, clearDebounce]);

	const onChangeSearch = useCallback(
		(value) => {
			setSearchInput(value);
			clearDebounce();

			debounceRef.current = setTimeout(() => {
				setSearch(value);
				debounceRef.current = null;
			}, debounceMs);
		},
		[clearDebounce, debounceMs],
	);

	const setSearchNow = useCallback(
		(value) => {
			clearDebounce();
			setSearchInput(value);
			setSearch(value);
		},
		[clearDebounce],
	);

	return {searchInput, search, onChangeSearch, setSearchNow};
}
